const Loading = () => {
    return (
        <div className="af-loading" role="status">
            <span className="af-spinner" />
            <span className="af-sr-only">Cargando...</span>
        </div>
    )
}
export default Loading
